import { styled } from 'styled-components';
import { SSpanQcu } from '~/components/styles/styles';
import { classic } from '~/themes';
import iconCheck from '@assets/images/icon/icon-check-white.png';
import iconClose from '@assets/images/icon/icon-close-white.png';

type IProps = {
  text: string;
  onClick?: () => void;
  selected: boolean;
  submitted: boolean;
  status?: 'good' | 'wrong' | 'neutral';
  disabled?: boolean;
};

type TProps = IProps;

export function QcuItem({
  text,
  onClick,
  selected,
  submitted,
  status,
  disabled,
}: TProps) {
  return (
    <Container
      $selected={selected}
      $submitted={submitted}
      $status={status}
      onClick={onClick}
      $disabled={disabled}
    >
      <SSpanQcu
        $fontWeight={
          (status === 'neutral' && !selected) ||
          (status === 'wrong' && !selected)
            ? '400'
            : '700'
        }
        $color={
          (status === 'neutral' && !selected) ||
          (status === 'wrong' && !selected)
            ? `${classic.token?.colorText}`
            : `${classic.token?.colorWhite}`
        }
      >
        {text}
      </SSpanQcu>
      {status === 'good' && (
        <SDivIcon $status={status}>
          <img src={iconCheck} alt="" />
        </SDivIcon>
      )}
      {status === 'wrong' && selected && (
        <SDivIcon $status={status}>
          <img src={iconClose} alt="" />
        </SDivIcon>
      )}
    </Container>
  );
}


const Container = styled.button<{
  disabled?: boolean;
  $status?: 'good' | 'wrong' | 'neutral';
  $submitted: boolean;
  $selected: boolean;
  $disabled?: boolean;
}>`
  align-items: center;
  cursor: ${({ $disabled }) => ($disabled ? 'auto' : 'pointer')};
  background-color: ${({ $submitted, $selected, $status }) => {
    if (!$submitted) {
      return $selected ? '#EA7A49' : '#ffffff80';
    } else {
      if ($status === 'good') return '#29AD66';
      if ($status === 'wrong' && $selected) return '#C6344F';

      return '#ffffff80';
    }
  }};
  border-radius: 20px;
  box-shadow:
    0px -4px 4px 0px rgba(0, 0, 0, 0.25) inset,
    0px 1px 3px 0px rgba(0, 0, 0, 0.25);
  border: ${({ $submitted, $selected, $status }) => {
    if (
      ($selected && !$submitted) ||
      ($submitted && ($status === 'good' || $status === 'wrong'))
    )
      return '2px solid #FFFFFFF5';
    return '2px solid #FFFFFF80';
  }};
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 14px;
  pointer-events: ${({ disabled, $submitted, $selected, $disabled }) =>
    disabled || $disabled || $submitted || $selected ? 'none' : 'auto'};
  user-select: none;
  position: relative;
  overflow: hidden;
  width: 100%;

  &:focus {
    border: 2px solid #ffffff;
    outline: none;
  }

  &:hover {
    border: 2px solid #ffffff;
    outline: none;
  }
`;

const SDivIcon = styled.div<{ $status?: 'good' | 'wrong' | 'neutral' }>`
  border-radius: 0px 17px 0px 18px;
  height: 36px;
  width: 36px;
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 0px 17px 0px 18px;
  background: ${({ $status }) => {
    if ($status === 'good')
      return 'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), #29AD66';
    if ($status === 'wrong')
      return 'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), #C6344F';
    return 'none';
  }};

  @media screen and (max-height: 450px) {
    height: 24px;
    width: 24px;
  }
  @media screen and (max-width: 450px) {
    height: 24px;
    width: 24px;
  }

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    object-fit: contain;
    height: 80%;
    width: 80%;
    transform: translate(-50%, -50%);
  }
`;
